// NEKSUS AKADEMİ — Numeroloji Eğitimi sayfa içeriği
export const COURSE = {
  hero: {
    brand: "NEKSUS AKADEMİ",
    audience: "Numeroloji Eğitimleri",
    title: "Temel · Orta · İleri Numeroloji Eğitimi",
    subtitle: "16 Haftalık Kapsamlı Uzmanlaşma Programı",
    description:
      "Temelden ileri düzeye uzanan kapsamlı bir Numeroloji eğitim süreci. Harf ve sayı sembolizmasını; sistemin çalışma mekanizması, parçalar arasındaki bağlantılar ve yorumlama becerisiyle birlikte ele alarak, Numerolojiyi bütünden okuyabilme becerisi geliştirmeyi amaçlayan 16 haftalık eğitim programı.",
    facts: [
      { icon: "calendar", label: "5 Kasım 2026 Perşembe" },
      { icon: "hourglass", label: "16 Hafta" },
      { icon: "video", label: "Zoom · Online Canlı Eğitim" },
      { icon: "clock", label: "20.30 – 22.30" },
    ],
    earlyNote: "Kayıtlar Açık",
  },
  curriculum: [
    {
      week: "1. Hafta",
      title: "Numerolojiye Giriş",
      blocks: [
        "Harf ve Sayı sembolizmasının ne olduğunu, nasıl bir sistem üzerine kurulduğunu ve tarihsel gelişimini ele alıyoruz.",
        "Sayıların yaşam içerisindeki karşılıklarını ve Numerolojinin yalnızca teorik bilgilerden ibaret olmayan bir okuma ve gözlem alanı olduğunu keşfediyoruz.",
        "Temel hesaplama yöntemleri ve sayıların çalışma biçimlerine giriş yaparken, bu bilginin hangi bakış açısı ve etik sorumlulukla kullanılması gerektiğini öğreniyoruz.",
      ],
    },
    {
      week: "2. Hafta",
      title: "Ne Nedir? · Sistemin Kavramsal Haritası",
      bullets: [
        "İnsanı ve zamanı okuma",
        "Enerji kapıları / Nefs mertebeleri",
        "Karma ve atalardan taşınan temalar",
        "Değer yaratacağımız alanlar",
        "Sistemin temel kavramları ve bağlantıları",
      ],
      blocks: [
        "Böylece sayı ve harfleri, ait oldukları yapı ve bağlantılar içerisinde okuyabilmenin temelini oluşturuyoruz.",
      ],
    },
    {
      week: "3. Hafta",
      title: "Harfoloji · Harf Sembolizması",
      blocks: [
        "Numeroloji eğitimlerinde çoğunlukla yer verilmeyen Harfoloji, Neksus eğitimindeki önemli yapı taşlarından biridir.",
        "Harfleri yalnızca sayısal karşılıklarıyla değil, kendi sembolik özellikleri ve kendine özgü yankılarıyla okumayı; harfin kendi yapısının temsil ettiği sayının çalışma biçimini nasıl etkileyebileceğini inceliyoruz.",
        "Aynı sayısal değere sahip harflerin neden aynı kaliteyi taşımadığını anlamak, ilerleyen haftalarda daha nokta atışı yorumlar yapabilmenin önemli parçalarından birini oluşturuyor.",
      ],
    },
    {
      week: "4–13. Haftalar",
      title: "1'den 9'a Sayıların ve Özel Kulvarların Derinlemesine İncelenmesi",
      blocks: [
        "Her sayı için bir ders ayırarak, sayıları yalnızca birkaç anlam veya davranış kalıbı üzerinden değil; çok yönlü bir yapı olarak ele alıyoruz.",
        "Sayıları bir madalyon gibi, hem zahiri hem de batıni yönleriyle inceliyoruz. Fiziksel ve dünyevi yansımalarının yanı sıra; ruhsal, psikolojik ve manevi boyutlarını, korkuları ve zorlanmaları, bunlarla baş etme biçimlerini, karmalarını ve beraberinde taşıdığı potansiyelleri ele alıyoruz.",
        "Her sayının çalışma mekanizmasını, imkanlarını ve imtihanlarını; farklı koşullarda nasıl tezahür ettiğini ve diğer yapılarla bağlantılarını inceliyoruz.",
        "Böylece bir sayıyı birkaç cümleyle tanımlamak yerine, kişide nasıl çalıştığını tespit etmeyi, getirdiği imkanları ve zorlanmaları görmeyi ve buna yönelik tavsiyeler ve yol haritaları belirlemeyi öğreniyoruz.",
        "11 · 22 · 33 gibi özel kulvarları da bu bütünlük içerisinde, kendi çalışma biçimleri ve potansiyelleriyle ele alıyoruz.",
      ],
    },
    {
      week: "14–15. Haftalar",
      title: "Yorumlama Becerileri",
      blocks: [
        "İlk 13 haftada oluşturduğumuz temeli ve öğrendiğimiz parçaları bir araya getirerek, bilgiler arasındaki ilişkileri ve bağlantıları görmeye başlıyoruz.",
        "Numerik haritayı bütünden değerlendirmeyi, doğru soruyu doğru yere sormayı ve farklı yapıların birbiriyle kurduğu bağlantılar üzerinden yorum geliştirmeyi öğreniyoruz.",
        "Böylece tek tek öğrenilen bilgiler, birbirleriyle ilişki kurarak anlamlı bir bütüne dönüşüyor.",
      ],
    },
    {
      week: "16. Hafta",
      title: "Döngüler ve Öngörü",
      blocks: [
        "İlk 15 haftada oluşturduğumuz temeli bu kez zaman boyutuyla buluşturarak, Numerik haritadaki farklı dönemlerin ve iç içe ilerleyen döngülerin nasıl çalıştığını ele alıyoruz.",
        "Zamanı tek bir dönem üzerinden değil, döngülerin birbirleriyle kurduğu ilişkiler ve oluşturduğu bütünlük üzerinden değerlendirmeyi öğreniyoruz.",
        "Böylece kişinin farklı yaş ve dönemlerde karşılaşabileceği süreçleri, değişim ve dönüşüm alanlarını zamanın bütünü içerisinde görerek öngörü geliştirmeye başlıyoruz.",
        "Bu hafta, Numerolojide öğrendiğimiz tüm yapıların zamanla birleştiği ve öngörü becerisinin temellerinin oluşturulduğu son aşamayı tamamlıyoruz.",
      ],
    },
  ],
  expectations: [
    {
      title: "Canlı ve interaktif dersler",
      text: "16 hafta boyunca derslere canlı katılarak konuları örnekler, uygulamalar ve soru-cevaplarla birlikte işliyoruz. Tüm ders kayıtlarına eğitim süresince ve sonrasında sınırsız erişim sağlayabiliyorsunuz.",
    },
    {
      title: "Neksus öğrencilerine özel eğitim kaynakları",
      text: "Eğitim sürecini desteklemek amacıyla hazırlanmış eğitim kılavuzları, çalışma materyalleri ve seçilmiş kaynaklar öğrencilerle paylaşılır.",
    },
    {
      title: "Sınıfa özel soru-cevap grubu",
      text: "Her sınıfın kendine özel soru-cevap ve paylaşım grubu bulunur. Eğitim süresince ve sonrasında sorularınızı paylaşabilir, bizden yanıt alabilir; öğrenci arkadaşlarınızla fikir ve deneyimlerinizi paylaşabilirsiniz.",
    },
  ],
  process: [
    "Neksus eğitimlerinde kayıt sürecini yalnızca bir ödeme işlemi olarak görmüyoruz. Eğitime başlamadan önce içerik, eğitim yaklaşımı ve süreç hakkında detaylı bilgi alabilir; mevcut bilgi ve deneyiminizi, beklentilerinizi ve ihtiyaçlarınızı bizimle paylaşabilirsiniz.",
    "Örnek ders kayıtları üzerinden ders anlatımını ve Neksus eğitim yaklaşımını daha yakından tanıyabilirsiniz.",
    "Asistanım ile iletişime geçerek aktif eğitim programı, başlangıç tarihi, kayıt süreci ve merak ettiğiniz tüm detaylar hakkında bilgi alabilirsiniz.",
    "Daha önce Numeroloji eğitimi aldıysanız mevcut bilgi seviyenizi ve deneyiminizi paylaşarak eğitim içeriğinin sizin için nasıl bir karşılık oluşturabileceği konusunda bilgi alabilirsiniz.",
    "Aktif bir eğitim dönemi bulunmuyorsa, bir sonraki eğitim programları ve başvuru süreçleri hakkında da bilgi alabilirsiniz.",
  ],
  pricing: [],
  secureNote:
    "Ödemelerinizi PayTR ödeme altyapısı üzerinden güvenli şekilde gerçekleştirebilirsiniz. Havale/EFT ile ödeme yapmak isteyenler, IBAN bilgileri ve ödeme süreci için bizimle iletişime geçebilir. Ödeme işleminizin ardından kayıt sürecinizle ilgili gerekli bilgilendirme tarafımızdan iletilecektir.",
  motto: [
    "Kendinle, başkalarıyla ve evrenle olan bağlantını hatırladığın yer.",
    "Bilgiyi, farkındalığı ve dönüşümü birleştiren merkez.",
  ],
};

// KİŞİSEL ÇALIŞMALAR — Kapsamlı Numeroloji Danışmanlığı
export const CONSULT = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "Kapsamlı Numeroloji Danışmanlığı",
  paragraphs: [
    "Kişinin yaşam planını, yaşam döngülerini, potansiyellerini, ihtiyaçlarını, zafiyetlerini ve yeteneklerini bütünsel olarak ele alan kapsamlı bir çalışmadır.",
    "Özellikle kişinin içinde bulunduğu dönemin ihtiyaçları ve önündeki süreçler değerlendirilerek, hayatının tam ortasından başlayıp bugünden yarına kişiye özel bir yol haritası oluşturulur. Çalışma, kişinin Numerik haritası üzerinden gerçekleştirilir.",
  ],
  facts: [
    { icon: "user", label: "Ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/JbDYvaY" },
    { label: "2 Taksit · 6.560 ₺", url: "https://www.paytr.com/link/kowXicE" },
    { label: "3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/WJrzS20" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, Kapsamlı Numeroloji Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, Kapsamlı Numeroloji Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};

// KİŞİSEL ÇALIŞMALAR — Çocuk / Öğrenci Danışmanlığı
export const COCUK = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "Çocuk / Öğrenci Danışmanlığı",
  paragraphs: [
    "0–18 yaş arası çocuk ve öğrencilerin fiziksel, duygusal, zihinsel ihtiyaçlarını, yeteneklerini, gelişim alanlarını ve mesleki yönelimlerini değerlendirerek ebeveynlere yol gösteren kişiye özel danışmanlıktır.",
    "15–18 yaş bireysel olarak katılabilir.",
  ],
  closing: [
    "Amaç; çocuğu tek bir alana yönlendirmek değil, onu daha doğru tanıyarak eğitim, gelişim ve gelecek yolculuğunda ebeveynlere daha bilinçli bir bakış açısı sunmaktır.",
  ],
  facts: [
    { icon: "user", label: "Ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/zSKUiIj" },
    { label: "2-3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/M9WrC9a" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, Çocuk / Öğrenci Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, Çocuk / Öğrenci Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};
export const SINASTRI = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "Sinastri Danışmanlığı · İlişkiler",
  paragraphs: [
    "İki kişinin haritaları üzerinden ilişkideki uyumlu, zorlayıcı ve gelişime açık alanları değerlendirerek; maddi ve manevi süreçlerde karşılıklı anlayışı güçlendirmeye ve sorunlara çözüm bulmaya yönelik öneriler sunan kişiye özel danışmanlıktır.",
  ],
  bullets: [
    "İletişim ve ilişki biçimlerini",
    "Birbirlerini destekledikleri ve zorladıkları alanları",
    "Tekrarlayan sorunların altında yatan dinamikleri",
    "İlişkide enerjinin kilitlendiği ve yeniden akabileceği alanları",
  ],
  closing: [
    "Yukarıdaki başlıkları ilişkiye özel olarak değerlendiriyoruz. Çalışma; partner, ebeveyn–çocuk ve aile içindeki diğer önemli ilişkiler için uygulanabilir.",
    "Amaç; ilişkiyi iyi ya da kötü olarak değerlendirmek değil, ilişkinin nasıl çalıştığını anlayarak daha sağlıklı bir iletişim ve ilişki biçimi geliştirebilmektir.",
  ],
  facts: [
    { icon: "user", label: "Ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/Rfx9XDu" },
    { label: "2-3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/LYZxYjQ" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, Sinastri Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, Sinastri Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};


// KİŞİSEL ÇALIŞMALAR — Öngörü Danışmanlığı (Dönem Analizi)
export const ONGORU = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "Öngörü Danışmanlığı",
  paragraphs: [
    "Kişinin içinde bulunduğu yaşam döngüsünü, dönemin potansiyellerini ve fırsatlarını; kariyer, ilişkiler, evlilik ve sorumluluklar gibi yaşam alanları üzerinden bütünsel olarak değerlendiren, kişiye özel öngörü danışmanlığıdır.",
  ],
  bullets: [
    "Tek konu çalışmalarında yalnızca odaklanılan alan üzerinden ilerlenir.",
    "Genel öngörü çalışmalarında ise dönem; ilişkiler, kariyer, maddi süreçler ve yaşamın diğer önemli alanları üzerinden bütünsel olarak değerlendirilir.",
  ],
  closing: [
    "Çalışmanın kapsamı ve zaman aralığı, kişinin ihtiyacına ve ele alınan konuya göre şekillenir.",
  ],
  facts: [
    { icon: "user", label: "Ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/ANkKYZB" },
    { label: "2-3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/FNcNTXK" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, Öngörü Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, Öngörü Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};

// KİŞİSEL ÇALIŞMALAR — İsim Değişikliği & Ek İsim Danışmanlığı
export const ISIM = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "İsim Değişikliği & Ek İsim Danışmanlığı",
  paragraphs: [
    "Mevcut ismin numerik haritayla bağlantısını değerlendirerek isim değişikliği veya ek isim seçeneklerini; kişinin potansiyelleri, yaşamındaki yansımaları ve ihtiyaçları doğrultusunda ele alan, kişiye özel bir yol haritası sunan bir danışmanlıktır.",
    "Danışmanlıkta istediğiniz sayıda isim seçeneği üzerinde çalışabiliriz. Numerik haritanıza en uygun seçenekleri, nedenleri ve hayatınızdaki yansımalarıyla birlikte size aktarırım.",
  ],
  closing: [
    "Aldığınız tüm bilgiler ışığında nihai karar her zaman danışana aittir.",
  ],
  facts: [
    { icon: "user", label: "Ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/kSU9WoT" },
    { label: "2-3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/hlIXmsz" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, İsim Değişikliği & Ek İsim Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, İsim Değişikliği & Ek İsim Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};

// KİŞİSEL ÇALIŞMALAR — Bebek İsmi Danışmanlığı
export const BEBEK = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "Bebek İsmi Danışmanlığı",
  paragraphs: [
    "Bebeğin doğum ayı, yılı ve coğrafi koşulları ile aile bireylerinin numerik haritaları birlikte değerlendirilerek, bebeğin yaşam planına ve potansiyellerine uygun isim seçeneklerinin aileyle birlikte belirlendiği kişiye özel danışmanlıktır.",
    "Ailenin danışmanlıkta sunduğu isim seçenekleri arasından, bu bütünlük içerisinde en uygun isim seçeneklerini tavsiye ediyor; seçilen ismin çocuğun fıtratına, varoluşuna ve karakter yapısına nasıl yansıyabileceğini, avantajları ve zorlanabileceği alanlarla birlikte aktarıyorum.",
  ],
  closing: [
    "Nihai olarak kararı ise her zaman aileye bırakıyorum.",
  ],
  facts: [
    { icon: "user", label: "Aile bireylerinin ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/byVEYDv" },
    { label: "2-3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/LoO4PQ9" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, Bebek İsmi Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, Bebek İsmi Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};

// KİŞİSEL ÇALIŞMALAR — İş Ortaklığı Sinastri Danışmanlığı
export const ORTAKLIK = {
  eyebrow: "Kişisel Çalışmalar · Numeroloji Danışmanlığı",
  title: "İş Ortaklığı Sinastri Danışmanlığı",
  paragraphs: [
    "İş ortaklarının bireysel haritaları ve ortaklık dinamikleri birlikte değerlendirilerek rol dağılımları, avantajlar, zorlanmalar, başarı potansiyeli ve riskler ele alınır; ortaklığın sağlıklı ilerlemesine yönelik öneriler sunulur.",
  ],
  bullets: [
    "Güçlü ve tamamlayıcı yönlerini",
    "Rol ve sorumluluk paylaşımını",
    "Karar alma ve iletişim biçimlerini",
    "Birbirlerini destekledikleri veya zorladıkları alanları",
    "Ortaklıktan doğacak kazanımlar ya da kayıp risklerini",
    "Ortaklığın sağlıklı ilerleyebilmesi için dikkat edilmesi gereken dinamikleri",
  ],
  closing: [
    "Amaç; kimin haklı ya da güçlü olduğunu belirlemek değil, kişilerin birlikte daha verimli çalışabilmesi için doğru rol ve işleyiş biçimini ortaya koymaktır.",
  ],
  facts: [
    { icon: "user", label: "Ad, soyad ve doğum tarihi yeterlidir · doğum saati gerekmez" },
    { icon: "video", label: "Zoom üzerinden canlı gerçekleştirilir" },
    { icon: "clock", label: "Süre: yaklaşık 1–1,5 saat" },
    { icon: "mic", label: "Görüşmenin ses kaydı görüşme sonrasında size iletilir" },
  ],
  payNote:
    "Danışmanlık ücretini PayTR bağlantısı üzerinden güvenli şekilde satın alabilirsiniz. Satın alma işleminizin ardından randevu planlaması için sizinle iletişime geçilecektir.",
  payOptions: [
    { label: "Tek Çekim · 6.380 ₺", url: "https://www.paytr.com/link/AXPI786" },
    { label: "2-3 Taksit · 6.740 ₺", url: "https://www.paytr.com/link/HvXzEIZ" },
  ],
  payUrl: "",
  payWaMessage: "Merhaba, İş Ortaklığı Sinastri Danışmanlığı satın alma linki almak istiyorum.",
  bookingMessage: "Merhaba, İş Ortaklığı Sinastri Danışmanlığı randevusu hakkında bilgi almak istiyorum.",
  transferNote: "Havale/EFT ile ödeme yapmak isterseniz, IBAN bilgileri için bizimle iletişime geçebilirsiniz.",
};

// NEKSUS NEDİR? — Site giriş bölümü (uzun tanıtım metni)
export const NEKSUS = {
  eyebrow: "Neksus Akademi · Nazife Çankaya Güder",
  title: "Neksus Nedir?",
  sections: [
    {
      heading: "Neksus Nedir?",
      paragraphs: [
        "Neksus; bağ, bağlantı noktası, merkez, her şeyin birleştiği kilit odak ve kadersel köprü anlamlarını taşır.",
        "Birbirinden tamamen bağımsız ve kopuk görünen parçaları, bilgileri, deneyimleri ve insanları, merkezde güçlü bir şekilde birbirine bağlayan görünmez bağı ifade eder.",
        "Neksus ismini de tam olarak bu anlamdan yola çıkarak seçtim.",
      ],
    },
    {
      heading: "Neksus Nasıl Doğdu?",
      paragraphs: [
        "Neksus, yalnızca bilgi aktaran bir eğitim yapısı oluşturma fikrinden değil; öğrenirken birbirine eşlik eden, birbirinden beslenen ve birlikte gelişen bir topluluk oluşturma arzusundan doğdu.",
        "Farklı hayatların, farklı insanların ve farklı deneyimlerin bir araya geldiği; insanların birbirlerinde kendilerinden bir parça bulabildiği, yeni dostluklar kurabildiği ve yaşamın içinde kurdukları bağlarla birbirlerine eşlik edebildiği bir merkez hayal ettim.",
        "Çünkü öğrenmenin yalnızca ders saatleriyle sınırlı olduğuna inanmıyorum. Birlikte öğrenmek, birbirine tanıklık etmek ve zaman içerisinde birbirindeki değişimi görebilmek de öğrenme sürecinin önemli bir parçası.",
        "Neksus'ta öğrencilerimin yalnızca aynı bilgiyi öğrenen kişiler olmalarını değil; birbirlerinin gelişimine tanıklık eden, gerektiğinde birbirine ayna olan ve zaman içerisinde değişimlerini birbirine hatırlatan bir topluluğun parçası olmalarını istedim.",
        "Aylar ve yıllar geçtikçe hayatlarımız değişiyor. Bazen kendimizde göremediğimiz bir dönüşümü, bizi uzun zamandır tanıyan biri fark edebiliyor. Ya da geçmişte kim olduğumuzu bize yine o insanlar hatırlatıyor.",
        "Neksus'u, bu bağların zaman içinde korunabildiği ve gelişebildiği bir merkez olarak hayal ettim.",
        "Bu yüzden Neksus benim için yalnızca bir eğitim çatısı değil; öğrenmenin, bağ kurmanın, birbirine tanıklık etmenin ve birlikte gelişmenin alanı.",
      ],
    },
    {
      heading: "Hangi Değerler Üzerine Kuruldu?",
      paragraphs: [
        "Neksus'ta öğreneceğiniz bilgi bir güç değil; doğru niyet, sorumluluk ve etik değerlerle taşınması gereken bir emanettir.",
        "Bu nedenle Neksus'un eğitim, danışmanlık ve bilgi aktarımındaki temel yaklaşımı vazgeçilmez ilkelere dayanır.",
      ],
      items: [
        {
          title: "1. Bilgiyi bir güç gösterisine dönüştürmemek",
          paragraphs: [
            "Sayı ve harf sembolizmasından elde edilen bilgiyi, kişinin üzerinde güç kurmak, kendisini üstün göstermek ya da “ben biliyorum” duygusunu beslemek için kullanmayı doğru bulmuyorum.",
            "Bilgi, karşı taraf üzerinde hâkimiyet kurmak için değil; anlamlandırmak, fark etmek ve kişinin kendi iradesini güçlendirmek için vardır.",
            "Bu nedenle Neksus'ta bilgi hiçbir zaman bir üstünlük aracına dönüştürülmez.",
          ],
        },
        {
          title: "2. Bilmediğini biliyormuş gibi sunmamak",
          paragraphs: [
            "Bir bilgiye sahip olmakla, o bilgi üzerinden her şeyi bilebileceğini iddia etmek aynı şey değildir.",
            "Neksus'ta sınırlarımızı bilmek, bilmediğimizi kabul etmek ve kesinlik iddiasında bulunmamak temel bir etik sorumluluktur.",
            "Kişilerin hayatları hakkında korku, kesin hüküm veya temelsiz umutlar oluşturacak söylemlerden kaçınırız.",
            "Çünkü bir insanın hayatına dokunan bilginin, beraberinde büyük bir sorumluluk taşıdığının bilincindeyiz.",
          ],
        },
        {
          title: "3. Korku ve bağımlılık yaratmamak",
          paragraphs: [
            "İnsanların korkularını, kaygılarını veya zorlandıkları yaşam alanlarını kullanarak onları yönlendirmek; korkutarak danışmanlığa, eğitime ya da yeni bir hizmete bağımlı hale getirmek Neksus çatısı altında asla kabul edilemez.",
            "Bir danışmanlık ya da eğitim sonrasında kişinin daha güçlü, daha bilinçli ve kendi kararlarını verebilir halde olması gerekir.",
            "Amaç kişiyi kendimize bağımlı kılmak değil, kendi ayakları üzerinde durabileceği bir bakış açısı kazandırmaktır.",
          ],
        },
        {
          title: "4. Bilgiyi kısa yoldan tüketilebilir bir ürüne dönüştürmemek",
          paragraphs: [
            "Bir sistemi birkaç gün içerisinde öğrenip uygulamaya başlayabileceğini, kısa süreli bir eğitimle uzmanlaşılabileceğini veya birkaç saatlik bilgiyle başkalarına danışmanlık verilebileceğini vadetmeyi doğru bulmuyorum.",
            "Gerçek öğrenmenin zamana, emeğe, gözleme, sorgulamaya ve deneyime ihtiyacı vardır.",
            "Bu nedenle Neksus eğitimleri, hızlı sonuç veya hazır yorumlar vermek üzerine değil; bilginin anlaşılması, sindirilmesi ve çalışma mekanizmasının kavranması üzerine kuruludur.",
            "Bilgiyi yüzeysel biçimde çoğaltmak yerine, onun sorumluluğunu taşıyabilecek bir anlayış geliştirmeyi amaçlıyoruz.",
          ],
        },
        {
          title: "5. Bilgiyi kirletmeden ve özünü değersizleştirmeden aktarmak",
          paragraphs: [
            "Bu alanın içinde dolaşan her bilginin doğru, yeterli veya güvenilir olduğunu düşünmüyorum.",
            "Özellikle kaynağı belirsiz, birbirinden kopyalanarak çoğaltılmış, bağlamından koparılmış ya da yeterince anlaşılmadan aktarılan bilgilerin zaman içerisinde hem kişileri hem de alanın kendisini yanlış yönlendirebildiğine inanıyorum.",
            "Bu nedenle Neksus'ta öğrenmek, araştırmak, sorgulamak, bilgiyi anlamlandırmak ve onu doğru bağlam içerisinde aktarmak temel bir sorumluluktur.",
            "Çünkü bize emanet edilen bilgiyi yalnızca öğrenmek değil, onu nasıl taşıdığımız ve bir başkasına nasıl aktardığımız da önemlidir.",
          ],
        },
      ],
      closingTitle: "Neksus'un temel duruşu",
      closingLines: [
        "İnsanın ihtiyacını sömürmeden.",
        "Korku üretmeden.",
        "Bilmediğini biliyormuş gibi davranmadan.",
        "Hazır cevaplar ve kısa yollar vaat etmeden.",
        "Bilgiyi bir güç gösterisine dönüştürmeden.",
        "Bilgiyi; sorumluluk, sınır, özgür irade ve etik değerlerle taşımak.",
      ],
      closing: [
        "Benim için mesele yalnızca ne bildiğimiz değil; bildiğimiz şeyi nasıl kullandığımızdır.",
        "Tüm öğrencilerimiz Neksus'un etik anlayışına uymak ile yükümlüdür.",
      ],
    },
    {
      heading: "Nasıl Bir Eğitim Anlayışını Temsil Ediyor?",
      paragraphs: [
        "Neksus'ta eğitim, yalnızca bilgi aktarmak üzerine kurulmaz.",
        "Bir bilgiyi bilmek ile onu anlayabilmek, anlamlandırabilmek ve doğru yerde kullanabilmek aynı şey değildir.",
        "Bu nedenle Neksus eğitimlerinde hazır yorumlar ve ezberlenmiş kalıplar vermek yerine; sistemin nasıl çalıştığını, parçaların birbirleriyle nasıl bağlantı kurduğunu ve bu bağlantılar üzerinden nasıl düşünülmesi gerektiğini öğrenmeye odaklanıyoruz.",
      ],
      items: [
        {
          title: "Parçadan Bütüne",
          paragraphs: [
            "Bir bütünü anlayabilmek için önce onu oluşturan parçaları anlamak gerekir.",
            "Neksus eğitimlerinde konuları parçadan bütüne doğru ele alıyor; her parçayı kendi anlamı ve işleyişi içinde inceliyoruz.",
            "Bilgiyi yalnızca tek bir boyuttan değil; zâhirî yani dünyevî ve görünen tarafıyla, bâtınî yani mânevî ve görünmeyen boyutuyla birlikte ele alıyoruz.",
            "Bütünü görmek, yalnızca parçaları bilmek değil; her parçanın farklı katmanlarını da fark edebilmektir.",
          ],
        },
        {
          title: "Bilginin Sürece İhtiyacı Var",
          paragraphs: [
            "Bilgi, aktarıldığı anda tamamlanmaz.",
            "Öğrenmek; anlamak, sorgulamak, gözlemlemek ve zaman içinde deneyimlemek demektir.",
            "Bu nedenle Neksus eğitimleri kısa ve yoğun bir bilgi aktarımı olarak değil, zamana yayılan bir öğrenme süreci olarak kurgulanır.",
            "Öğrencinin öğrendiği bilgiyi farklı örneklerle karşılaştırmasına, hayatın içinde gözlemlemesine, üzerinde düşünmesine ve zaman içinde kendi kalp süzgecinden geçirmesine alan açılır.",
            "Böylece kalp süzgecinden geçen bilgi, kişinin kendi öz bilgisine dahil olur. Bilginin yerleşmesi ve anlam kazanması için zamana ihtiyacı vardır.",
          ],
        },
        {
          title: "Bilgiden İdraka",
          paragraphs: [
            "Bilgiyi almak ilk adımdır.",
            "Bilgi, kişi onu hazmedip kendi deneyimiyle ilişkilendirdiğinde zihinsel bir verinin ötesine geçer.",
            "İdrak, bilginin içimizden geçerek doğal biçimde ulaştığı fark ediş halidir.",
          ],
        },
        {
          title: "İdraktan Dönüşüme",
          paragraphs: [
            "İdrak, bir şey hakkında yalnızca bilgi sahibi olmak değil; o bilginin hayatımızdaki karşılığını gerçekten görmeye başlamaktır.",
            "Bir şeyi idrak ettiğimizde, daha önce tekrar tekrar yaşadığımız olaylara, ilişkilere, seçimlere ve hayatımızdaki döngülere artık aynı yerden bakmayız. Bir şeyin iç yüzünü gördüğümüzde, bakışımız değişir; bakışımız değiştiğinde ise hayatımızdaki karşılıkları da doğal olarak değişmeye başlar.",
            "Bu nedenle Neksus'ta dönüşümü ayrı bir çaba ya da uygulanacak bir yöntem olarak görmüyoruz.",
            "Asıl yol idrake ulaşana kadar yürünendir. İdrak gerçekleştiğinde ise dönüşüm, hayatın içinde doğal olarak kendini göstermeye başlar.",
            "İlişkilerimizde, kariyerimizde, seçimlerimizde ve bugüne kadar tekrar eden yaşam deneyimlerimizde fark etmeden aynı yerde dönüp durduğumuz döngüler değişmeye başlar. Çünkü gerçek idrak, hayatı değiştirmeye çalışmak değil; artık hayata aynı yerden bakamamaktır.",
          ],
        },
        {
          title: "Bakış Açısını Genişletmek",
          paragraphs: [
            "İdrak ve dönüşümle birlikte, olaylara ve insanlara artık tek bir doğru, tek bir yorum ya da tek bir ihtimal üzerinden bakmamaya başlarız.",
            "Aynı durumun farklı koşullarda farklı anlamlar taşıyabileceğini; bir parçanın bütünden bağımsız değerlendirilemeyeceğini görürüz.",
            "Bakış açısını genişletmek, her ihtimali doğru kabul etmek değil; gördüğümüzün bütünü temsil etmeyebileceğini fark etmektir.",
            "Böylece hem Numerik haritaya hem de hayatın kendisine daha geniş, daha esnek ve daha bütüncül bir yerden bakabilme becerisi geliştiririz.",
          ],
        },
        {
          title: "Ve bütün bunların merkezinde...",
          paragraphs: [
            "Ben sana ne göreceğini söylemiyorum; baktığın yerde neyi, nerede ve nasıl görebileceğini öğretiyorum.",
            "Çünkü bu sistemde hazır cevaplar biriktirmek, o sistemi gerçekten okuyabilmek anlamına gelmez.",
            "Sayı nereye yerleştiğinde nasıl çalışır? Hangi parçayla birleştiğinde anlamı nasıl değişir? Hangi sorunun cevabını nerede aramak gerekir?",
            "Bunları ve daha birçok şeyi anlayan kişi, karşısına daha önce hiç görmediği bir örnek geldiğinde de ne yapacağını bilir.",
            "Benim için gerçek öğrenme, öğrencinin cevapları sürekli bende araması değil; öğrendiği bilgilerle kendi sentezini, yorumunu ve eylemini ortaya koyuyor olmasıdır.",
            "Çünkü ben öğrencilerime yalnızca kanat çırpmayı değil, kendi kanatlarıyla uçabilmeyi öğretmeyi hedefliyorum.",
          ],
        },
      ],
    },
  ],
};

// NEKSUS ATÖLYELERİ — Sayfa sonu atölye bölümü
export const ATOLYELER = {
  eyebrow: "Neksus Atölyeleri",
  title: "Keşif · Derinleşme · Deneyim",
  paragraphs: [
    "Neksus Atölyeleri; bilgiyi yalnızca aktarmakla kalmayıp, farklı konular üzerinden keşfetmeye, deneyimlemeye ve derinleştirmeye alan açan dönemsel çalışmalardır.",
    "Atölyelerin içerikleri ve hedef kitlesi dönemsel olarak değişebilir. Numeroloji bilgisi gerektirmeyen, Neksus bakış açısıyla tanışmaya yönelik ücretsiz Keşif & Deneyim Atölyelerinin yanı sıra; Neksus eğitimlerinde edinilen bilgilerin üzerine inşa edilen, belirli konularda derinleşmeye ve yorumlama becerisini geliştirmeye yönelik çalışmalar da düzenliyoruz.",
    "Güncel atölye, tarih ve katılım bilgileri aşağıdaki bölümlerde paylaşılır.",
    "Henüz listelenmemiş veya planlama aşamasındaki atölyeler hakkında bilgi almak için bizimle iletişime geçebilirsiniz.",
  ],
  groups: [
    {
      heading: "Keşif & Deneyim Atölyeleri",
      tag: "Ücretsiz",
      paragraphs: [
        "Numeroloji bilgisi gerektirmeyen, Neksus bakış açısıyla tanışmaya ve belirli konuları örnekler üzerinden keşfetmeye yönelik herkese açık atölyelerdir.",
      ],
      workshop: {
        label: "Ücretsiz Numeroloji Atölyesi",
        title: "1'i Anlamadan, Bütünü Görebilir miyiz?",
        paragraphs: [
          "Bir sayıyı bilmek, onun bütün yansımalarını görebilmek için yeterli midir?",
          "Bu atölyede 1 sayısının karşılığında yer alan A, S, Ş ve J harflerini kendi sembolik yapıları ve farklı yansımaları üzerinden örneklerle inceliyoruz.",
          "Neksus eğitimlerinde özel bir yere sahip olan Harfoloji yaklaşımından küçük bir kesit sunarak, aynı sayıyı temsil eden harflerin neden birbirinden farklı etkiler bıraktığını birlikte keşfediyoruz.",
        ],
      },
      joinMessage: "Merhaba, Ücretsiz Numeroloji Atölyesi'ne katılmak istiyorum.",
    },
    {
      heading: "Derinleşme Atölyeleri",
      paragraphs: [
        "Neksus eğitimlerinde edinilen bilgilerin üzerine inşa edilen, belirli konularda daha derinleşmeye ve yorumlama becerisini geliştirmeye yönelik çalışmalardır.",
        "Bu alandaki atölyeler dönemsel olarak açılır ve güncel çalışmalar burada paylaşılır.",
        "Henüz listelenmemiş veya planlama aşamasındaki atölyeler hakkında bilgi almak için bizimle iletişime geçebilirsiniz.",
      ],
      joinMessage: "Merhaba, Derinleşme Atölyeleri hakkında bilgi almak istiyorum.",
    },
  ],
};